import styled from 'styled-components';

import Image from '../../Core/Image';

export const AppStoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1.5rem 0;

  a {
    display: flex;
    margin: auto 1rem auto 0;
    justify-content: flex-start;

    svg {
      width: 135px;

      @supports (-moz-appearance: none) {
        width: 135px;
      }
    }
  }

  &.column {
    margin: 4rem;
    flex-direction: column;
    a {
      margin-bottom: 4rem;
      margin-right: 0;
    }

    a:last-child {
      margin-bottom: 0rem;
    }
  }
`;

export const StyledImage = styled(Image)`
  width: 135px;
`;
